import { NgModule } from '@angular/core';

import { DiscussionStateModule } from '../../state/state';
import { DiscussionFormHelperContentComponent } from '../discussion-form-container/discussion-form-helper-content.component';
import { DiscussionFormStepperComponent } from '../discussion-form-container/discussion-form-stepper.component';
import { DiscussionFormParticipantsComponent } from '../discussion-participants/discussion-form-participants.component';
import { DiscussionUnsavedChangesComponent } from '../discussion-unsaved-changes/discussion-unsaved-changes.component';

import { DiscussionCommitmentsFormComponent } from './discussion-commitments-form/discussion-commitments-form.component';
import { DiscussionCoreValuesFormComponent } from './discussion-core-values-form/discussion-core-values-form.component';
import { DiscussionCustomQuestionFormComponent } from './discussion-custom-question-form/discussion-custom-question-form.component';
import { DiscussionPerfDataFormComponent } from './discussion-performance-data-form/discussion-perf-data-form.component';
import { DiscussionRoleRatingsFormComponent } from './discussion-role-ratings-form/discussion-role-ratings-form.component';

/** Exposes components and state used for filling out a Discussion form or meeting */
@NgModule({
  imports: [
    DiscussionCoreValuesFormComponent,
    DiscussionRoleRatingsFormComponent,
    DiscussionCommitmentsFormComponent,
    DiscussionPerfDataFormComponent,
    DiscussionCustomQuestionFormComponent,
    DiscussionFormParticipantsComponent,
    DiscussionFormHelperContentComponent,
    DiscussionFormStepperComponent,
    DiscussionUnsavedChangesComponent,
    DiscussionStateModule,
  ],
  exports: [
    DiscussionCoreValuesFormComponent,
    DiscussionRoleRatingsFormComponent,
    DiscussionCommitmentsFormComponent,
    DiscussionPerfDataFormComponent,
    DiscussionCustomQuestionFormComponent,
    DiscussionFormParticipantsComponent,
    DiscussionFormHelperContentComponent,
    DiscussionFormStepperComponent,
    DiscussionUnsavedChangesComponent,
  ],
})
export class DiscussionFormsModule {}
